import $ from '@vaersaagod/tools/Dom';

const ANIMATION = 'bounce';

export default el => {
    const count = $(el).find('[data-count]');

    const update = showAnimation => {
        count.text(Snipcart.api.items.count());
        if (showAnimation) {
            count.addClass(ANIMATION);
        }
    };

    const snipcartReady = () => {
        update(false);
        TweenLite.set(el, { scale: 0.5 });
        TweenLite.to(el, 0.15, { delay: 1.15, autoAlpha: 1, ease: Circ.easeOut });
        TweenLite.to(el, 0.35, { delay: 1.15, scale: 1, ease: Back.easeOut });
        Snipcart.subscribe('item.added', update);
        Snipcart.subscribe('item.removed', update);
    };

    const init = () => {
        document.addEventListener('snipcart.ready', snipcartReady);
        count.on('animationend', () => { count.removeClass(ANIMATION); });
    };

    const destroy = () => {
        document.removeEventListener('snipcart.ready', snipcartReady);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Checkout.js